import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const React = require("react");
import { Container } from "./library/container";
import { Teaser } from "./teaser";
export class GridBlock extends React.Component {
    render() {
        const p = this.props;
        return /*#__PURE__*/ _jsx("section", {
            className: "block block--collections collections",
            children: /*#__PURE__*/ _jsxs(Container, {
                children: [
                    p.title && /*#__PURE__*/ _jsx("header", {
                        className: "block__header",
                        children: /*#__PURE__*/ _jsx("h2", {
                            className: "block__title title--l",
                            children: p.title
                        })
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        className: "row teasers",
                        children: p.items.map((item, index)=>/*#__PURE__*/ _jsx(Teaser, {
                                title: item.title,
                                headingLevel: "h2",
                                intro: item.intro,
                                imageUrl: item.imageUrl,
                                imageUrlFallback: item.imageUrlFallback,
                                imageAlt: item.imageAlt,
                                linkUrl: item.linkUrl,
                                row_count: p.row_count
                            }, 'teaser-' + index))
                    })
                ]
            })
        });
    }
}
